import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_3 = {
  key: 2,
  class: "mt-4 divide-y"
}
const _hoisted_4 = { class: "font-medium" }
const _hoisted_5 = {
  key: 0,
  class: "ml-2 rounded bg-blue-100 px-2 py-0.5 text-xs text-blue-800"
}
const _hoisted_6 = { class: "text-sm text-gray-500" }
const _hoisted_7 = { class: "bg-white rounded-lg shadow-xl w-full max-w-md p-6" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_9 = { class: "mt-5 flex justify-end gap-2" }

import { ref, watch } from 'vue'

import EmptyState from '@/components/neue/EmptyState.vue'
import InputField from '@/components/neue/InputField.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import NeueWell from '@/components/neue/NeueWell.vue'
import { usePhoneInput } from '@/composables/usePhoneInput'
import api from '@/store/api'


export default {
  __name: 'ResellerMembers',
  props: {
  resellerId: { type: [String, Number], required: true },
  members: { type: Array, required: true }
},
  emits: ['updated'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const addOpen = ref(false)
const newName = ref('')
const error = ref('')
const saving = ref(false)
const togglingId = ref(null)
const toggleError = ref('')
// The phone widget mounts with the modal and clears itself when it closes.
const memberPhone = usePhoneInput(addOpen)
const memberPhoneBox = memberPhone.container

// Clear the rest of the form whenever the modal closes, whether from Cancel
// or a successful add.
watch(addOpen, open => {
  if (!open) {
    newName.value = ''
    error.value = ''
  }
})

const addMember = async () => {
  if (!memberPhone.valid.value || saving.value) return
  error.value = ''
  saving.value = true
  try {
    const res = await api.call('POST', `resellers/${props.resellerId}/members`, {
      name: newName.value,
      ...memberPhone.payload()
    })
    addOpen.value = false
    emit('updated', res?.data?.data)
  } catch (e) {
    error.value = e?.response?.data?.errors?.[0] || 'Could not add team member.'
  } finally {
    saving.value = false
  }
}

const toggleMember = async member => {
  toggleError.value = ''
  togglingId.value = member.id
  try {
    const res = await api.call('PATCH', `resellers/${props.resellerId}/members/${member.id}`, {
      is_active: !member.is_active
    })
    emit('updated', res?.data?.data)
  } catch (e) {
    toggleError.value = e?.response?.data?.errors?.[0] || 'Could not update team member.'
  } finally {
    togglingId.value = null
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(NeueWell, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Team Members", -1)),
        _createVNode(NeueButton, {
          size: "sm",
          onClick: _cache[0] || (_cache[0] = $event => (addOpen.value = true))
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("Add team member", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " Team members log in with their own phone number and share this reseller's customers and orders. ", -1)),
      (toggleError.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(toggleError.value), 1))
        : _createCommentVNode("", true),
      (!__props.members.length)
        ? (_openBlock(), _createBlock(EmptyState, {
            key: 1,
            class: "mt-4",
            plural: "team members",
            description: "No team members added yet."
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.members, (member) => {
              return (_openBlock(), _createElementBlock("div", {
                key: member.id,
                class: "flex items-center justify-between py-3"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(member.display_name), 1),
                  (member.is_primary)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Primary "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["ml-2 rounded px-2 py-0.5 text-xs", member.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'])
                  }, _toDisplayString(member.is_active ? 'Active' : 'Inactive'), 3),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(member.phone_number), 1)
                ]),
                _createVNode(NeueButton, {
                  type: "secondary",
                  size: "sm",
                  loading: togglingId.value === member.id,
                  onClick: $event => (toggleMember(member))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(member.is_active ? 'Deactivate' : 'Reactivate'), 1)
                  ]),
                  _: 2
                }, 1032, ["loading", "onClick"])
              ]))
            }), 128))
          ])),
      (addOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "fixed inset-0 z-40 flex items-center justify-center bg-black/40",
            onClick: _cache[4] || (_cache[4] = _withModifiers($event => (addOpen.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-lg font-semibold mb-4" }, "Add team member", -1)),
              _createVNode(InputField, {
                modelValue: newName.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((newName).value = $event)),
                name: "Name",
                class: "mt-4 w-full"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", {
                ref_key: "memberPhoneBox",
                ref: memberPhoneBox,
                class: "mt-4"
              }, [
                _createVNode(InputField, {
                  modelValue: _unref(memberPhone).phone.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_unref(memberPhone).phone.value) = $event)),
                  name: "Phone number",
                  type: "tel",
                  class: "w-full"
                }, null, 8, ["modelValue"])
              ], 512),
              (error.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(error.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(NeueButton, {
                  type: "secondary",
                  onClick: _cache[3] || (_cache[3] = $event => (addOpen.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Cancel", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(NeueButton, {
                  type: _unref(memberPhone).valid.value ? 'primary' : 'inactive',
                  loading: saving.value,
                  onClick: addMember
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" Add team member ", -1)
                  ]))]),
                  _: 1
                }, 8, ["type", "loading"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

}